<div class="container-xl h-100">
    <div class="row crud-header">
        <div class="col flex-shrink-0 text-nowrap d-flex align-items-center gap-3">
            <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                 class="controls-left-button"
                 matTooltip="Terug naar projectenkaart"
                 matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">Interfacing</h1>
        </div>
        <div class="col d-flex align-items-center gap-2">
        </div>

        <div class="col justify-content-center d-flex flex-column">
            <input #searchInput class="searchInput" placeholder="Zoeken" type="text"/>
        </div>
    </div>
    <div class="row" style="height: calc(100vh - 100px);">
        <div class="col-6 overflow-auto h-100">
                        <div *ngFor="let entity of entities" (click)="active(entity)">
                            <b>{{entity.project?.name}}</b>
                            <small>{{entity.name}}</small>
                        </div>
        </div>
        <div class="col-6">
            <google-map
                height="100%"
                width="100%"
                #googleMap
                (mapRightclick)="addPointToExtra($event)"
                [center]="center"
                [zoom]="setZoom"
                [options]="options">
                <div class="controls-left">
                    <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}" tabindex="1" matTooltip="Verlaat project"
                         matTooltipPosition="after">
                        <i class="fa fa-arrow-left-from-arc"></i>
                    </div>
                    <div (click)="toggleMapType()" tabindex="4" matTooltip="Wissel tussen kaartlagen" matTooltipPosition="after">
                        <i class="fa fa-layer-group"></i>
                    </div>
                </div>
                @for (point of extras; let i = $index; track i) {
                    <map-advanced-marker
                        [zIndex]="999"
                        (mapClick)="removeExtra($event, i)"
                        (mapDragend)="changeSelectionExtra($event, i)"
                        [gmpDraggable]="true"
                        [title]="'a' + i"
                        [position]="point"></map-advanced-marker>
                }

                @for (point of basicpoints; let i = $index; track i) {
                    <map-advanced-marker
                        [zIndex]="999"
                        [gmpDraggable]="true"
                        [title]="'b' + i"
                        [position]="point"></map-advanced-marker>
                }


                @for (entity of filteredEntities; track entity.id) {
                    @if (entity.bbox) {
                        <app-svg-overlay
                            zIndex="101"
                            [entity]="entity"
                            [downlight]="!(filteredEntities | byId : entity.id)"
                            [click]="selectEntity"
                            [map]="googleMap"></app-svg-overlay>
                    }
                    @if (!entity.gnd_handle) {
                        @for (coordinates of (entity.gnd | gndLine); track $index) {
                            <map-polyline [options]="{zIndex: 5, strokeWeight: 8, strokeColor: '#FF0000'}"
                                          [path]="coordinates"/>
                        }

                        @if (!entity.line && entity.pole) {
                            <map-polyline
                                [options]="{zIndex: 5, strokeWeight:2, strokeColor: mapTypeId === 'hybrid' ? '#ffffff' : '#000000'}"
                                [path]="[entity.gnd | geoLatLng, entity.pole | geoLatLng]"/>
                        }
                    }
                    <map-polyline
                        [options]="{zIndex: 5, strokeWeight:2, strokeColor: '#AA0000'}"
                        [path]="line" />

                }


            </google-map>

        </div>
    </div>
</div>
